import { NgModule, inject } from '@angular/core';

import { FuseUtilsService } from './utils.service';
@NgModule({
  providers: [FuseUtilsService]
})
export class FuseUtilsModule {
  private __fuseUtilsService = inject(FuseUtilsService);
}
